import { Query } from "@gen/app-query";
import { useMemo } from "react";

import { Money } from "~/utilities/money";

export interface CurrencyOption {
  code: string;
  label: string;
  symbol: string;
  value: string;
}

export function useCurrencies() {
  const { data: currencyData } =
    Query.useCore_getSupportedTransactionCurrenciesQuery();

  const currencies = useMemo(() => {
    if (!currencyData?.currencies) {
      return [];
    }

    const locale = navigator?.language || "en-US";
    const displayNames = new Intl.DisplayNames(locale, {
      type: "currency",
    });

    return currencyData.currencies.map(
      (currencyCode: string): CurrencyOption => {
        let label = displayNames.of(currencyCode.toUpperCase());
        if (!label) {
          label = currencyCode.toUpperCase();
        }

        let symbol;
        try {
          symbol = Money.getCurrencyInfo(currencyCode).symbol;
          if (!symbol) {
            symbol = currencyCode.toUpperCase();
          }
        } catch {
          symbol = currencyCode.toUpperCase();
        }

        return {
          code: currencyCode.toUpperCase(),
          label,
          symbol,
          value: currencyCode,
        };
      },
    );
  }, [currencyData?.currencies]);

  return { currencies };
}
